// extracted by mini-css-extract-plugin
export var _noQuery = "search-module--_noQuery--509bf";
export var btn = "search-module--btn--4b6cb";
export var closeBtn = "search-module--closeBtn--993fa";
export var form = "search-module--form--21df7";
export var input = "search-module--input--10878";
export var overlay = "search-module--overlay--f9db4";
export var overlayInner = "search-module--overlayInner--15479";
export var searchBtn = "search-module--searchBtn--710d5";